<div class="container">
  <div class="main-wrapper">
    <div class="page-header-title" i18n>Create new user</div>

    <div class="content-card-background">
      <h2 i18n>Personal information</h2>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="input-row">
          <label for="fname" i18n>First name</label>
          <div>
            <input type="text" id="fname" [formControl]="form.controls.firstName" />
            <app-generic-error [control]="form.get('firstName')"></app-generic-error>
          </div>
        </div>
        <div class="input-row">
          <label for="lname" i18n>Last name</label>
          <div>
            <input type="text" id="lname" [formControl]="form.controls.lastName" />
            <app-generic-error [control]="form.get('lastName')"></app-generic-error>
          </div>
        </div>
        <div class="input-row">
          <label for="position" i18n>Position</label>
          <div>
            <input type="text" id="position" [formControl]="form.controls.function" />
            <app-generic-error [control]="form.get('function')"></app-generic-error>
          </div>
        </div>
        <div class="input-row">
          <label for="email" i18n>E-mail</label>
          <div>
            <input type="text" id="email" [formControl]="form.controls.email" />
            <app-generic-error [control]="form.get('email')"></app-generic-error>
          </div>
        </div>
        <div class="input-row">
          <label for="phone" i18n>Phone number</label>
          <div>
            <ngx-material-intl-tel-input
              id="phone"
              class="tel-input"
              [fieldControl]="form.controls.phone"
              [preferredCountries]="[CountryISO.Netherlands]"
              [autoSelectedCountry]="CountryISO.Netherlands"
              [autoIpLookup]="false"
              [autoSelectCountry]="true"
              [enablePlaceholder]="false"
              [enableSearch]="true"
              [numberValidation]="true"
              [includeDialCode]="false"
              [hidePhoneIcon]="true"
              [textLabels]="phoneTextLabels"></ngx-material-intl-tel-input>
            <app-generic-error [control]="form.get('phone')"></app-generic-error>
          </div>
        </div>
        <div class="input-row">
          <label i18n>Language</label>
          <div class="button-group-border">
            <div class="button-group">
              <div
                class="group-button active"
                (click)="changeLanguage('Dutch')"
                [class.selected]="form.controls.language.value === LanguageType.DUTCH">
                <a [ngStyle]="form.controls.language.value === LanguageType.DUTCH && {'color': 'white'} || {}" i18n>Dutch</a>
              </div>
              <div
                class="group-button"
                (click)="changeLanguage('English')"
                [class.selected]="form.controls.language.value === LanguageType.ENGLISH">
                <a [ngStyle]="form.controls.language.value === LanguageType.ENGLISH && {'color': 'white'} || {}" i18n>English</a>
              </div>
            </div>
          </div>
        </div>
        <div class="input-row">
          <div class="photo-label-wrapper">
            <label class="photo-label" i18n>Profile Photo</label>
            <p class="photo-optional" i18n>Optional</p>
          </div>
          <div class="image-upload">
            <input type="file" accept="image/jpeg,image/png" (change)="imageUpload($event)" />
            @if (photoDeleted) {
              <div class="photo-deleted"><i class="fal fa-user"></i></div>
            }
            @if (files.length > 0) {
              <img src="{{ files[0].base64 }}" alt="" />
            }
            <div class="image-upload-bottom">
              <p i18n>Upload</p>
            </div>
          </div>
        </div>
        <h2 class="rights" i18n>Rights</h2>

        <div class="admin-row">
          <label class="admin-label" i18n>Admin</label>
          <input type="checkbox" id="admin" (click)="toggleAdmin()" />
          <label class="checkbox-label" for="admin"></label>
          <label class="checkbox-option" for="admin" i18n>Yes, user has admin rights</label>
        </div>

        <ng-container>
          <div class="label-row">
            <label i18n>Available labels</label>
            @if (admin) {
              <label class="admin-user-label" i18n>All labels</label>
            } @else {
              <div class="input-wrapper">
                <app-multi-select
                  [labels]="labels"
                  [showControlButtons]="true"
                  [formControl]="form.controls.labels"
                  [multiSelectType]="MultiSelectType.LABEL"></app-multi-select>
              </div>
            }
          </div>
        </ng-container>

        <div class="row footer-row">
          <div class="col-sm-12 table-footer-right">
            <button class="save-button" type="submit" i18n>Create account</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
